module.exports = __webpack_public_path__ + "static/img/freezer_sports.a3d5e55.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/freezer_sports.jpg
// module id = Y61v
// module chunks = 1